import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Tooltip } from "@mui/material";
import { SoundLibraryAI } from "../../types/types";
import AudioPlayerRewind from "../common/AudioPlayer";
import Icon from "../common/Icon";
import listStyles from "./ProjectAudioModalList.module.css";

interface ProjectAudioModalListProps {
    audioOptions: SoundLibraryAI[];
    onClick: (item: SoundLibraryAI) => void;
    search?: string;
}

const ProjectAudioModalList: React.FC<ProjectAudioModalListProps> = ({ audioOptions, onClick, search = "" }) => {
    const { t: rawT } = useTranslation();
    const t = rawT as any;

    const [selectedSound, setSelectedSound] = useState<SoundLibraryAI | null>(null);

    const filteredItems = audioOptions.filter((item) => {
        if (!search) return true;
        const searchLower = search.toLowerCase();
        return (
            (item.name && item.name.toLowerCase().includes(searchLower)) ||
            (item.soundDescription && item.soundDescription.toLowerCase().includes(searchLower))
        );
    });

    return (
        <div className={`${listStyles.container}${selectedSound ? ` ${listStyles.containerWithPlayer}` : ""}`}>
            {filteredItems.length === 0 ? (
                <div className="no-items-message">{t("noSoundsFound")}</div>
            ) : (
                <div className={listStyles.listBody}>
                    {filteredItems.map((item, index) => (
                        <div key={item.id || index} className={listStyles.item}>
                            <button
                                type="button"
                                className={listStyles.play}
                                onClick={() => setSelectedSound(item)}
                                aria-label={t("play") || "Play"}
                            >
                                <Icon name="ic-play" />
                            </button>
                            <div className={listStyles.name}>
                                <Tooltip title={`${t("name")}: ${item.name}`} placement="bottom-start">
                                    <h4>{item.name}</h4>
                                </Tooltip>
                                <Tooltip
                                    title={`${t("description")}: ${item.soundDescription}`}
                                    placement="bottom-start"
                                >
                                    <p>{item.soundDescription}</p>
                                </Tooltip>
                            </div>
                            <div className={listStyles.editButtons}>
                                <button type="button" className={listStyles.editButton} onClick={() => onClick(item)}>
                                    {t("add")}
                                </button>
                            </div>
                        </div>
                    ))}
                </div>
            )}

            {selectedSound && (
                <div className={listStyles.playerFooter}>
                    <div className={listStyles.playerFooterInner}>
                        <AudioPlayerRewind
                            title={selectedSound.name}
                            src={selectedSound.url}
                            showAddtoProject={false}
                            hideDownload
                            isAutoPlay={true}
                            hideSeparator
                            embedded
                        />
                        <button
                            type="button"
                            className={listStyles.playerClose}
                            onClick={() => setSelectedSound(null)}
                            aria-label={t("close")}
                        >
                            <Icon name="ic-x" className="ic" size={18} />
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
};

export default ProjectAudioModalList;
